import { SCANNING_PEAK_HEATMAP_COLORS } from '../../../ScanningPeakHoursWidget.settings';

/** Heatmap level 0 = empty; 1–7 = intensity */
export const getScanningPeakHeatLevel = (count: number, maxCount: number): number => {
  if (maxCount <= 0 || count === 0) {
    return 0;
  }

  const level = Math.ceil((count / maxCount) * 7);
  return Math.min(7, Math.max(1, level));
};

export const getCellColor = (count: number, maxCount: number): string => {
  const level = getScanningPeakHeatLevel(count, maxCount);

  return SCANNING_PEAK_HEATMAP_COLORS[level] ?? SCANNING_PEAK_HEATMAP_COLORS[0];
};
